// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-popup .btns {
  height: 50px;
  border-radius: 5px;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  text-transform: none;
  border: 1px solid;
  /* color: inherit; */
  color: #000000;
  border-color: inherit;
  font-family: Poppins;
  width: 100%;
  /* margin: 0px auto; */
  display: flex;
  justify-content: center;
  padding: 0px;
}
.react-datepicker__day--outside-month {
  color: #8b8b8b !important;
}

.calendar-popup .btn-default {
  border-color: #444444;
  background-color: #444444;
}
.calendar-popup .btn-default:hover {
  border-color: #444444;
  background-color: #444444;
}

.calendar-popup .btns-green {
  border-color: #50c878;
  background-color: #50c878;
}
.calendar-popup .btns-green:hover {
  border-color: #50c878;
  background-color: #50c878;
}

.custom-calendar {
  width: 100%;
  font-family: sans-serif Pro;
  font-size: 14px;
  border: none;
}
.calendar-popup .react-datepicker__month {
  margin: 0;
  text-align: left;
}
.calendar-popup .react-datepicker__month-container {
  width: 100%;
  height: 400px;
}

.calendar-popup .react-datepicker__header {
  background-color: white !important;
  /* border-bottom: 1px solid #ddd; */
  width: 100% !important;
  border: none;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  text-align: center;
}
/* custom header part  */
.calendar-popup .custom-header {
  width: 100% !important;
  height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 6px;
  margin-right: auto;
  margin-left: auto;
}

.calendar-popup .header-title {
  font-family: "Poppins" !important;
  font-weight: 590 !important;
  font-weight: bold;
  font-size: 17px;
  line-height: 22px;
  color: #000000;
  letter-spacing: -0.5px;
}

.header-buttons {
  display: flex;
  gap: 8px;
}

.header-buttons button {
  background: transparent;
  border: none;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  padding: 5px;
  color: #333;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.header-buttons button:hover {
  background-color: #f0f0f0;
}

.header-buttons button:disabled {
  color: #ccc;
  cursor: not-allowed;
}
/* end custom header */

.calendar-popup .react-datepicker__day-names {
  padding: 10px 10px 10px 0px;
  display: flex;
  justify-content: space-between;
  /* padding: 0 !important;
  margin: 0 !important; */
}
.react-datepicker__day-names .react-datepicker__day-name {
  width: 50px;
  height: 18px;
  line-height: 18px;
  font-family: sans-serif Pro;
  font-weight: 400;
  font-size: 13px;
  color: #444444;
}
.calendar-popup .react-datepicker__day {
  border-radius: 50%;
  width: 51.5px;
  height: 44px;
  line-height: 25px;
  font-family: sans-serif Pro;
  font-weight: 400;
  font-size: 20px;
  line-height: 44px;
  letter-spacing: -0.45px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  margin: 2px;
  text-align: center;
  transition: none;
}

.calendar-popup .react-datepicker__day:hover {
  background-color: #191818;
  color: #fff;
  border-radius: 50%;
  transform: scale(0.8);
}

.calendar-popup .react-datepicker__day--selected,
.calendar-popup .react-datepicker__day--selected:hover,
.calendar-popup .react-datepicker__day--keyboard-selected {
  background-color: #191818 !important;
  color: white !important;
  font-weight: bold;
  border: none !important;
  border-radius: 50% !important;
  transform: scale(0.8);
}

.apply-date-button {
  margin-top: 16px;
  width: 100%;
  padding: 12px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.3s ease;
}
.react-datepicker__day--today {
  border: 1px solid #191818;
  color: #333;
  font-weight: bold;
  background-color: white;
}

.calendar-popup .react-datepicker__day--selected {
  background-color: #191818;
  color: white;
  font-weight: bold;
}

.calendar-popup .reset-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  color: #333;
  border: none;
  padding: 6px 30px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  z-index: 20;
  font-family: "Karla";
  font-weight: 500;
}
.compact-calendar .react-datepicker__day--selected,
.compact-calendar .react-datepicker__day--keyboard-selected {
  background-color: #000 !important;
  color: #fff !important;
  border-radius: 50% !important;
}

.compact-calendar .react-datepicker__day:hover {
  background-color: #333 !important;
  color: #fff !important;
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/features/Setting/order/components/calender.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,YAAY;AACd;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA,sBAAsB;;AAEtB;EACE,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B;yBACuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;EAGE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;EAEE,iCAAiC;EACjC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":[".calendar-popup .btns {\n  height: 50px;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 27px;\n  text-transform: none;\n  border: 1px solid;\n  /* color: inherit; */\n  color: #000000;\n  border-color: inherit;\n  font-family: Poppins;\n  width: 100%;\n  /* margin: 0px auto; */\n  display: flex;\n  justify-content: center;\n  padding: 0px;\n}\n.react-datepicker__day--outside-month {\n  color: #8b8b8b !important;\n}\n\n.calendar-popup .btn-default {\n  border-color: #444444;\n  background-color: #444444;\n}\n.calendar-popup .btn-default:hover {\n  border-color: #444444;\n  background-color: #444444;\n}\n\n.calendar-popup .btns-green {\n  border-color: #50c878;\n  background-color: #50c878;\n}\n.calendar-popup .btns-green:hover {\n  border-color: #50c878;\n  background-color: #50c878;\n}\n\n.custom-calendar {\n  width: 100%;\n  font-family: sans-serif Pro;\n  font-size: 14px;\n  border: none;\n}\n.calendar-popup .react-datepicker__month {\n  margin: 0;\n  text-align: left;\n}\n.calendar-popup .react-datepicker__month-container {\n  width: 100%;\n  height: 400px;\n}\n\n.calendar-popup .react-datepicker__header {\n  background-color: white !important;\n  /* border-bottom: 1px solid #ddd; */\n  width: 100% !important;\n  border: none;\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n  text-align: center;\n}\n/* custom header part  */\n.calendar-popup .custom-header {\n  width: 100% !important;\n  height: 44px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 6px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.calendar-popup .header-title {\n  font-family: \"Poppins\" !important;\n  font-weight: 590 !important;\n  font-weight: bold;\n  font-size: 17px;\n  line-height: 22px;\n  color: #000000;\n  letter-spacing: -0.5px;\n}\n\n.header-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.header-buttons button {\n  background: transparent;\n  border: none;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n  padding: 5px;\n  color: #333;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n}\n\n.header-buttons button:hover {\n  background-color: #f0f0f0;\n}\n\n.header-buttons button:disabled {\n  color: #ccc;\n  cursor: not-allowed;\n}\n/* end custom header */\n\n.calendar-popup .react-datepicker__day-names {\n  padding: 10px 10px 10px 0px;\n  display: flex;\n  justify-content: space-between;\n  /* padding: 0 !important;\n  margin: 0 !important; */\n}\n.react-datepicker__day-names .react-datepicker__day-name {\n  width: 50px;\n  height: 18px;\n  line-height: 18px;\n  font-family: sans-serif Pro;\n  font-weight: 400;\n  font-size: 13px;\n  color: #444444;\n}\n.calendar-popup .react-datepicker__day {\n  border-radius: 50%;\n  width: 51.5px;\n  height: 44px;\n  line-height: 25px;\n  font-family: sans-serif Pro;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 44px;\n  letter-spacing: -0.45px;\n  display: inline-block;\n  text-align: center;\n  cursor: pointer;\n  margin: 2px;\n  text-align: center;\n  transition: none;\n}\n\n.calendar-popup .react-datepicker__day:hover {\n  background-color: #191818;\n  color: #fff;\n  border-radius: 50%;\n  transform: scale(0.8);\n}\n\n.calendar-popup .react-datepicker__day--selected,\n.calendar-popup .react-datepicker__day--selected:hover,\n.calendar-popup .react-datepicker__day--keyboard-selected {\n  background-color: #191818 !important;\n  color: white !important;\n  font-weight: bold;\n  border: none !important;\n  border-radius: 50% !important;\n  transform: scale(0.8);\n}\n\n.apply-date-button {\n  margin-top: 16px;\n  width: 100%;\n  padding: 12px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  text-align: center;\n  transition: background-color 0.3s ease;\n}\n.react-datepicker__day--today {\n  border: 1px solid #191818;\n  color: #333;\n  font-weight: bold;\n  background-color: white;\n}\n\n.calendar-popup .react-datepicker__day--selected {\n  background-color: #191818;\n  color: white;\n  font-weight: bold;\n}\n\n.calendar-popup .reset-btn {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  color: #333;\n  border: none;\n  padding: 6px 30px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  z-index: 20;\n  font-family: \"Karla\";\n  font-weight: 500;\n}\n.compact-calendar .react-datepicker__day--selected,\n.compact-calendar .react-datepicker__day--keyboard-selected {\n  background-color: #000 !important;\n  color: #fff !important;\n  border-radius: 50% !important;\n}\n\n.compact-calendar .react-datepicker__day:hover {\n  background-color: #333 !important;\n  color: #fff !important;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
